/* ==========================================================================
   Main Collection — La Europea
   Sort dropdown + filter drawer toggle logic.
   ========================================================================== */

(function () {
  /* ---- Sort Dropdown ---- */
  const sortWrappers = document.querySelectorAll('[data-sort-toggle]');

  sortWrappers.forEach(function (wrapper) {
    const dropdown = wrapper.querySelector('[data-sort-dropdown]');
    if (!dropdown) return;

    function openDropdown() {
      dropdown.classList.add('is-open');
      wrapper.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
      dropdown.classList.remove('is-open');
      wrapper.setAttribute('aria-expanded', 'false');
    }

    function toggleDropdown() {
      if (dropdown.classList.contains('is-open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    }

    wrapper.addEventListener('click', function (e) {
      /* Don't toggle if clicking a sort option */
      if (e.target.closest('[data-sort-value]')) return;
      toggleDropdown();
    });

    wrapper.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleDropdown();
      }
      if (e.key === 'Escape') {
        closeDropdown();
      }
    });

    /* Sort option click — navigate to sorted URL */
    dropdown.querySelectorAll('[data-sort-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sortBy = btn.getAttribute('data-sort-value');
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortBy);
        window.location.href = url.toString();
      });
    });

    /* Close on click outside */
    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        closeDropdown();
      }
    });
  });

  /* ---- Filter Drawer ---- */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterDrawer = document.querySelector('[data-filter-drawer]');
  var filterOverlay = document.querySelector('[data-filter-overlay]');
  var filterClose = document.querySelector('[data-filter-close]');

  /* Portal drawer + overlay al <body> para escapar cualquier ancestro
     con transform/will-change/filter que rompa position: fixed. */
  if (filterOverlay && filterOverlay.parentElement !== document.body) {
    document.body.appendChild(filterOverlay);
  }
  if (filterDrawer && filterDrawer.parentElement !== document.body) {
    document.body.appendChild(filterDrawer);
  }

  function openFilter() {
    if (filterDrawer) filterDrawer.classList.add('is-open');
    if (filterOverlay) filterOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeFilter() {
    if (filterDrawer) filterDrawer.classList.remove('is-open');
    if (filterOverlay) filterOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (filterToggle) filterToggle.addEventListener('click', openFilter);
  if (filterClose) filterClose.addEventListener('click', closeFilter);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilter);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFilter();
  });

  /* ---- Collapsible filter groups ---- */
  var filterToggles = document.querySelectorAll('[data-filter-group-toggle]');
  filterToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var content = toggle.nextElementSibling;
      toggle.setAttribute('aria-expanded', String(!expanded));
      if (content) content.classList.toggle('is-open', !expanded);
    });
  });

  /* ---- Filter selection: visual toggle only (no auto-reload) ---- */
  if (filterDrawer) {
    filterDrawer.addEventListener('change', function (e) {
      var input = e.target.closest('.sp-main-collection__filter-input');
      if (!input) return;

      var label = input.closest('.sp-main-collection__filter-link');
      var box = label ? label.querySelector('.sp-main-collection__filter-checkbox') : null;
      if (label) label.classList.toggle('is-active', input.checked);
      if (box) box.classList.toggle('is-checked', input.checked);
    });
  }

  /* ---- Apply / Clear buttons ---- */
  var filterApply = filterDrawer ? filterDrawer.querySelector('[data-filter-apply]') : null;
  var filterClearButtons = document.querySelectorAll('[data-filter-clear]');

  function getCollectionUrl() {
    var base = filterDrawer && filterDrawer.getAttribute('data-collection-url');
    return base || window.location.pathname;
  }

  function buildBaseUrl() {
    var url = new URL(getCollectionUrl(), window.location.origin);
    var currentSort = new URL(window.location.href).searchParams.get('sort_by');
    if (currentSort) url.searchParams.set('sort_by', currentSort);
    return url;
  }

  if (filterApply) {
    filterApply.addEventListener('click', function () {
      var url = buildBaseUrl();

      var checked = filterDrawer.querySelectorAll('.sp-main-collection__filter-input:checked');
      checked.forEach(function (input) {
        var name = input.getAttribute('data-param-name');
        var value = input.getAttribute('data-param-value');
        if (name && value) url.searchParams.append(name, value);
      });

      var priceInputs = filterDrawer.querySelectorAll('.sp-main-collection__price-input');
      priceInputs.forEach(function (input) {
        var name = input.getAttribute('data-param-name');
        var value = input.value.trim();
        if (name && value !== '') url.searchParams.set(name, value);
      });

      window.location.href = url.toString();
    });
  }

  filterClearButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      window.location.href = buildBaseUrl().toString();
    });
  });
})();
